import React from 'react';
import { ActivationCard } from './ActivationCard';

interface SuccessScreenProps {
  login?: string;
  onGoToLogin: () => void;
  title?: string;
  message?: string;
  alertMessage?: string;
}

export const SuccessScreen: React.FC<SuccessScreenProps> = ({
  login,
  onGoToLogin,
  title = 'Congratulations!',
  message = 'Your RFID registration has been completed successfully.',
  alertMessage = 'Your account is now active and ready to use.',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <p className="text-muted mb-4">{message}</p>
      <div className="alert alert-success" role="alert">
        <i className="fas fa-check me-2"></i>
        {alertMessage}
      </div>
      {login && (
        <p className="text-muted small mb-4">
          Signed in as: <strong>{login}</strong>
        </p>
      )}
      <button onClick={onGoToLogin} className="btn btn-primary w-100">
        <i className="fas fa-sign-in-alt me-2"></i>
        Go to Login
      </button>
    </div>
  </ActivationCard>
);
